import { render, staticRenderFns } from "./SlideConstructor.vue?vue&type=template&id=6a674e7f&"
import script from "./SlideConstructor.vue?vue&type=script&lang=js&"
export * from "./SlideConstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports